import {ModalWithNewForm, Select} from '~/components'
import {Input} from '@eitje/web_components'
import {useParams} from '@eitje/bridge'
import {Admin} from '@eitje/api'
import {goBack} from '~/routing/actions'
import {ResourceFetcher} from '~/services'

const ROLES = [
	{id: 'admin', t: 'roles.admin'},
	{id: 'moderator', t: 'roles.moderator'},
]

export const EditAdmin = () => {
	const {id} = useParams()
	const user = Admin.useFind(id)

	if (!user) return <ResourceFetcher id={id} kind="admins" />

	const onDelete = () => user.destroy()

	return (
		<ModalWithNewForm
			name="edit_admin"
			onSubmit={params => user.update(params)}
			afterSubmit={goBack}
			modalProps={{okButtonProps: {t: 'common.save'}, onDel: onDelete}}
			width={348}
			initialValues={{...user}}
		>
			<Input field="name" required />
			<Input field="email" required />
			<Select field="role" items={ROLES} required />
			<Input field="password" />
		</ModalWithNewForm>
	)
}
